<div class="header">
	<div class="type-row">
		<ion-icon (click)="goBack()" class="back" src="../../../assets/topgolf/back-button.svg"></ion-icon>
		<div class="type-block">
			@for (type of preorderTypes; track type) {
				<div (click)="onSelectType(type)" [class.selected]="selectedTypeValue == type" class="button-type">
					{{ 'preorder_type.' + type | translate }}
				</div>
			}
		</div>
		<app-burger-btn></app-burger-btn>
	</div>
	<ion-input
		[formControl]="searchControl"
		[placeholder]="'map_page.mobile_header_title' | translate"
		class="title"
		lines="none"
	></ion-input>
	<div class="version">{{ version }}</div>
</div>
